export default __webpack_public_path__ + "static/media/plus_icon.986d85b8.svg";